export function Terms() {
  return (
    <div className="min-h-screen py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-white mb-8">Terms of Service</h1>
        <div className="prose prose-invert prose-gray max-w-none space-y-6 text-gray-300">
          <p className="text-lg text-gray-400">
            <strong>Last updated:</strong> {new Date().toLocaleDateString()}
          </p>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white mt-8 mb-4">Agreement to Terms</h2>
            <p>
              By accessing or using our service, you agree to be bound by these Terms of Service.
              If you disagree with any part of these terms, you may not use our service.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white mt-8 mb-4">Use of Service</h2>
            <p>
              You agree to use the service only for lawful purposes and in accordance with these Terms.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white mt-8 mb-4">Contact Us</h2>
            <p>
              If you have any questions about these Terms, please contact us.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
